export default "__VITE_ASSET__D_GqA5h1__"